module.exports = __webpack_public_path__ + "static/media/cwiczenie_9.5ec58b9d.jpg";